import { ArrayInput, SimpleFormIterator } from "react-admin";
import "rsuite/DateRangePicker/styles/index.css";
import { TrackReferenceInput } from "./customFields";
import { SettingsPage, SettingsUpdate } from "./settingUpdate";

export const FeaturedTracks = () => {
    return (
        <SettingsPage title="Featured tracks">
            <SettingsUpdate url="/cms/featured_tracks">
                <p>Home screen featured tracks</p>
                <ArrayInput source="track_ids" fullWidth label="Tracks">
                    <SimpleFormIterator inline>
                        <TrackReferenceInput />
                    </SimpleFormIterator>
                </ArrayInput>
            </SettingsUpdate>
        </SettingsPage>
    );
};

export const CuratedTracks = () => {
    return (
        <SettingsPage title="Curated tracks">
            <SettingsUpdate url="/cms/curated_tracks">
                <p>First tracks shown to new users</p>
                <ArrayInput source="track_ids" fullWidth label="Curated tracks">
                    <SimpleFormIterator inline>
                        <TrackReferenceInput />
                    </SimpleFormIterator>
                </ArrayInput>
            </SettingsUpdate>
        </SettingsPage>
    );
};
